module.exports = {
	name: 'KrPanoInsights',
	provides: 'krPanoInsights',
	main: 'krpano_insights.js',
	dependencies: {
		/** @type Logger */
		logger: true,

		/** @type KrPanoClient */
		krPanoClient: true,

		/** @type jQuery */
		jQuery: true,

		/** @type Location */
		location: false,
	},
	init: 'init'
};
